import { render } from "./ImageGallery.vue?vue&type=template&id=4768de42&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"

import "./ImageGallery.vue?vue&type=style&index=0&id=4768de42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4768de42"]])

export default __exports__